import React from 'react'
import Sidenav from '../components/navigation/Sidenav'
import Content from '../components/outlet/Content'
import Profile from '../components/profile/Profile'
import './myself.css' 


export default function Myself() {
  return (
    <div className='bgcntr'>
        <div className='maincntr'>
            <Sidenav />
            <Content />
            <Profile />
        </div>
    </div>
  )
}
